<template>
    <h5>Billing</h5>

    <table class="table table-striped">
        <thead>
            <tr>
                <th>Invoice #</th>
                <th>Amount</th>
                <th>Due Date</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody class="table-border-bottom-0">

            <tr v-if="!filteredItems || filteredItems.length === 0">
                <td colspan="4" style="text-align: center;">No billing found</td>
            </tr>

            <tr v-else v-for="item in filteredItems"  :key="item.transaction_id">
                <td>
                    <strong>{{ item.reference_id }}</strong> 
                </td>
                <td>{{ item.amount }}</td>
                <td>{{ item.date }}</td>
                <td>
                    <DetailLinkComponent :data="item.transaction_id" />
                </td>

            </tr>
            
        </tbody>
    </table>
</template>

<script>
    import DetailLinkComponent from './invoice/DetailLink.vue';
    export default {
        components: { DetailLinkComponent },
        props: {
            transactions: {
                type: Array,
                default: () => [],
            },
        },
        computed: {
            filteredItems() {
                let items = this.transactions.filter(item => item.type === 'invoice' && item.status != 'paid');
                localStorage.setItem('billingCount', items.length);
                return items;
            }
        }
    };
</script>
